"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validMenuSections = exports.MENU_SECTION_CREATE_MAX_AT_ONE_TIME = exports.MENU_SECTION_NAME_MAX_LENGTH = void 0;
const instance_1 = __importDefault(require("./instance"));
const errorMessageGenerator_1 = require("../utils/errorMessageGenerator");
exports.MENU_SECTION_NAME_MAX_LENGTH = 255;
exports.MENU_SECTION_CREATE_MAX_AT_ONE_TIME = 10;
exports.validMenuSections = instance_1.default
    .array()
    .of(instance_1.default.object({
    name: instance_1.default
        .string()
        .required(errorMessageGenerator_1.requiredError)
        .max(exports.MENU_SECTION_NAME_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(exports.MENU_SECTION_NAME_MAX_LENGTH))
}))
    .max(exports.MENU_SECTION_CREATE_MAX_AT_ONE_TIME);
//# sourceMappingURL=menuPlanner.js.map